'use client';

import SectionWrapper from '@/components/SectionWrapper';
import React from 'react';
import { businessInfo as business } from '@/content/globals';

export default function CeramicCoatingEducation() {
  return (
    <SectionWrapper className="shadow-lg">
      <div className="text-secondary bg-secondary/10 px-4 py-12">
        <div className="mx-auto max-w-4xl">
          <h2 className="mb-6 text-center text-3xl font-bold">
            What is Ceramic Coating &amp; Why It’s Essential for Your Vehicle
          </h2>
          <p className="mb-4 text-lg text-gray-700">
            Ceramic coating is a premium liquid polymer that creates a
            resilient, long-lasting barrier over your vehicle’s paint. This
            advanced treatment provides superior protection against scratches,
            swirl marks, and harmful UV rays while maintaining a high-gloss
            finish that makes your car look brand new.
          </p>
          <p className="mb-4 text-lg text-gray-700">
            At <strong>{business.name} and Ceramic Coatings</strong>, we combine
            the art of professional car detailing with cutting-edge paint
            protection technology. Our ceramic coating service not only offers
            unmatched durability and hydrophobic properties that repel water and
            grime but also delivers exceptional UV protection. This ensures that
            your vehicle remains in pristine condition, whether you're looking
            for a high-performance coating or simply the best automotive ceramic
            coating available.
          </p>
          <p className="mb-4 text-lg text-gray-700">
            Serving {business.address.city} and beyond, our service is designed
            with both quality and search engine optimization in mind. We
            specialize in terms such as automotive ceramic coating, car
            detailing, paint protection, hydrophobic coating, and professional
            ceramic coating in
            {business.address.city}. By integrating these concepts seamlessly
            into our process, we ensure that your vehicle receives top-tier
            protection and an unmatched shine.
          </p>
          <p className="text-lg text-gray-700">
            Experience the difference with our comprehensive ceramic coating
            service, where state-of-the-art technology meets expert
            craftsmanship to deliver the ultimate in car care.
          </p>
        </div>
      </div>
    </SectionWrapper>
  );
}
